<template>
  <div class="allergy-kpis__nav">
    <ul id="tabs" class="nav h-center-align">
      <NavTab v-for="(section, index) in sectionsList" :key="`section-${index}`" :active-section="activeSection" :section-name="section.label" :section-key="section.value"></NavTab>
    </ul>
    <StoreConnectedSelect class="allergy-kpis__mobile-dropdown" store="allergyKpis" name="activeSection" :options="sectionsList" close-on-select></StoreConnectedSelect>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import NavTab from './NavTab.vue';
  import StoreConnectedSelect from '../form-items/StoreConnectedSelect.vue';

  export default {
    name: 'Navigation',
    components: {
      NavTab,
      StoreConnectedSelect,
    },
    data() {
      return {
        sectionsList: [
          { label: 'Charts', value: 'charts' },
          { label: 'Performance', value: 'performance' },
          { label: 'Tracking', value: 'tracking' },
        ],
      };
    },
    computed: {
      ...mapGetters('allergyKpis', ['activeSection']),
    },
  };
</script>
